/* @ngInject */
export default function AssignmentIntroModalController(
  exercise,
  moment,
) {
  this.exercise = exercise;
  this.moment = moment;
}
